import { Injectable, signal } from '@angular/core';

export type AppError = { message: string; code?: string };

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private _queue: AppError[] = [];
  readonly errorTick = signal(0);

  report(err: AppError) {
    this._queue.push(err);
    this.errorTick.update(v => v + 1);
  }

  dequeue(): AppError | null {
    return this._queue.shift() ?? null;
  }
}